import {Directive, Input, TemplateRef, ViewContainerRef} from '@angular/core';
import {Image} from "../../data/models/image";

/**
 * Diese Direktive überprüft, ob HTML-Elemente valide Werte (d.h. != null && != '' && != undefined) beinhalten:
 * wenn der Wert valide ist, wird das Element gerendert, sonst wird es aus dem DOM entfernt.
 * Grund dafür: Assistive Gadgets wie z. B. Screenreaders etc. lesen leere HTML-Elemente falsch vor.
 */
@Directive({
  selector: '[appApplyIfNotEmpty]',
  standalone: true
})
export class ApplyIfNotEmptyDirective {

  constructor(
    public templateRef: TemplateRef<any>,
    public viewContainer: ViewContainerRef
  ) {
  }

  @Input('appApplyIfNotEmpty') set appApplyIfNotEmpty(value: string | null | undefined | Image) {
    if (typeof value === 'string' && value.trim() || (value instanceof Image && value.type)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
